import { Button, ComponentStyle} from '@/imports-files/components/confirmation-modal';
import { sendOfferToCandidate } from '@/imports-files/pages/clients/candidates/kanban';

export function SendOfferModal({setBtnPopup, sendOfferPopup, heightClass, setInitialData})
{

  return(
          <div className = {`CandidateFilterModal ${ComponentStyle.ConfirmationModal}`}>
            <div className={`${ComponentStyle.ConfirmationModal__Inner} ${heightClass}`}>
              <div className={ComponentStyle.ConfirmationModal__Container}>
                <h1> Offer Approved</h1>
                  <span className={ComponentStyle.ConfirmationModal__Message}>Congratulations!! You have received all the required approvals for this offer. Its time to send it to the candidate.</span>
                  <div className={ComponentStyle.ConfirmationModal__ButtonSection}>
                    <Button buttonstyle={ComponentStyle.primarybtn} type="button" onClick={async() => {
                      await sendOfferToCandidate({id: sendOfferPopup.offer_id, from: 'application_view', kanban: {candidate_index: props.candidateIndex, base_stage_id: props.paramStageId}}, setBtnPopup, setInitialData)
                    }}> Send Offer</Button>
                    <Button buttonstyle={ComponentStyle.secondarybtn} type="button" onClick={()=> {
                      setBtnPopup({state: false})
                    }}> Cancel</Button>
                  </div>
              </div>
            </div>
          </div>
        )
} 

